import React, { useContext, useState } from 'react';
import ImageUpload from '../../shared/components/FormElements/imageUpload';
import { AuthContext } from '../../shared/context/auth-context';
import { useForm } from '../../shared/hooks/form-hook';

import './userProfile.css'

const UserProfile = () => {

  const { user, updateUser } = useContext(AuthContext);
  const [isLoaded, setIsLoaded] = useState(false); 
  const [formState, inputHandler ] = useForm(
    { 
        image: {
          value: null,
          isValid: false
        }
      },
      false
  )

  const changeImage = async (e) => {

    e.preventDefault();
        const isConfirmed = window.confirm("Are you sure to change it?");

        if(!isConfirmed){
          console.log("Change the image cancelled! ")
          return;
        };

    setIsLoaded(true);

    const formData = new FormData();
    formData.append('image', formState.inputs.image.value); // Append an image file

    console.log('this is a formState inputs. ', formState.inputs.image.value);

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/${user.id}`, {
        method: 'PATCH',
        body: formData,
        
        
      });

      if (!response.ok){
        throw new Error('Failed to update profile image')
      };

      const responseData = await response.json();
  

      updateUser ({ ...user, image: responseData.user.image });
        // updateUser(updatedUser);


      // Update local storage with the new user information
      localStorage.setItem(
        'user',
        JSON.stringify({
          user: { ...user, image: responseData.user.image },
          token: localStorage.getItem('token'), // Make sure the token remains the same
        })
      );
  
    } catch (err) {
      console.log(err.message)
      
    } finally {
      setIsLoaded(false);
    }
  }

  if(isLoaded) {
    return (
        <div style={{textAlign:'center'}}>Loading...</div>
    )
  }
 

  return (
    <main>
      <section className='user-mobileProfile-section'>
      <h3 style={{textAlign:'center'}}>{user.name}'s Profile</h3>      
        <ImageUpload  
          center 
          id='image' 
          onInput={inputHandler} 
          image={`${process.env.REACT_APP_ASSET_URL}/${user.image}` }
          onClick={changeImage}
        />
      
      <div className='user-profile-container'>
        <div className='user-profile-change'>Change user name</div>
        <div className='user-profile-change'>Change password</div>
        <div className='user-profile-change'> LinkedIn </div>
        <div className='user-profile-change'> Github</div>
       
        
      </div>
      </section>
    </main>
  )
}
export default UserProfile;